import { useCheckPermissions } from '@/shared';

import { PermissionsEnum } from '@/auth/interfaces';
import SaveCooperativa from '../../saveCooperativa/saveCooperativa';

export interface CreateEntidadesFinancierasPageInterface {}

const CreateCooperativaPage: React.FC<CreateEntidadesFinancierasPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_add_entidadfinanciera)
  return <SaveCooperativa titlePage="Crear cooperativa" />;
};

export default CreateCooperativaPage;
